module.exports = __webpack_public_path__ + "Roboto-MediumItalic.5b25afa871e1b8960118.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/fonts/roboto/Roboto-MediumItalic.ttf
// module id = 387
// module chunks = 2